import { render, staticRenderFns } from "./page.vue?vue&type=template&id=181d7482&scoped=true&"
import script from "./page.js?vue&type=script&lang=js&"
export * from "./page.js?vue&type=script&lang=js&"
import style0 from "./page.css?vue&type=style&index=0&id=181d7482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d7482",
  null
  
)

export default component.exports